import getGlobalConfig from './globalConfig';

export const _private = {
    getGlobalConfig
};

/**
 * Helper function to read continuous scan setting with precedence
 * Priority: tenant settings > feature flags > default (false)
 * @param {string} [settingName='continuousScan'] - The setting name to read
 * @returns {boolean} The setting value
 */
function readWithPrecedence(settingName = 'continuousScan') {
    const globalConfig = _private.getGlobalConfig();
    const tenantSettings = globalConfig.tenantSettings || {};
    const featureFlags = globalConfig.featureFlags || [];

    // Priority: tenant settings > featureFlags > default false
    if (tenantSettings?.[settingName] !== undefined) {
        return tenantSettings[settingName];
    }
    if (featureFlags.includes(settingName)) {
        return true;
    }
    return false;
}

/**
 * Get the continuousScan tenant setting
 * Returns whether continuous scan mode is enabled
 * @returns {boolean} True if continuous scan is enabled, false otherwise
 */
export function isContinuousScanEnabled() {
    // Debug override for testing
    // @ts-ignore
    if (typeof window !== 'undefined' && window.__FORCE_CONTINUOUS_SCAN__) {
        console.log('[continuousScanSettings] Continuous scan FORCED via window.__FORCE_CONTINUOUS_SCAN__');
        return true;
    }

    const result = readWithPrecedence('continuousScan');
    const globalConfig = _private.getGlobalConfig();
    console.log('[continuousScanSettings] Checking continuous scan - tenantSettings:', globalConfig.tenantSettings, 'featureFlags:', globalConfig.featureFlags, 'result:', result);
    return result;
}

export default {
    isContinuousScanEnabled
};
